import * as React from 'react';

import { ResponsivePie } from '@nivo/pie';
import { GenderItem } from '@webapp/types/ui/analytics/gender-item';

import styled, { useTheme } from 'styled-components';

interface DoughnutGraphProps {
  className?: string;
  data: GenderItem[];
  customSize?: string;
  margin?: number;
}

export const DoughnutGraph: React.FC<DoughnutGraphProps> = (props) => {
  const theme = useTheme();
  const [hasData, setHasData] = React.useState<GenderItem[]>([]);

  React.useEffect(() => {
    let animation = setTimeout(() => setHasData(props.data), 5);

    return () => {
      clearTimeout(animation);
    };
  }, [props.data]);

  const getColor = (id: any): string => {
    const result = props.data.find((item) => item.id === id);
    return result?.color || theme.colors.primary;
  };

  const getTextColor = () => {
    return theme.colors.primary;
  };

  const graphMargin = () => {
    if (props.margin) {
      return {
        top: props.margin,
        right: props.margin,
        bottom: props.margin,
        left: props.margin,
      };
    } else {
      return {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10,
      };
    }
  };

  return (
    <div className={props.className}>
      <ResponsivePie
        data={hasData}
        margin={graphMargin()}
        innerRadius={0.8}
        cornerRadius={45}
        colors={(d) => getColor(d.id)}
        borderWidth={0}
        borderColor={getTextColor()}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        arcLinkLabelsSkipAngle={0}
        arcLinkLabelsTextColor={getTextColor()}
        isInteractive={false}
        animate={true}
        padAngle={4}
        motionConfig="molasses"
        transitionMode="startAngle"
        legends={[]}
      />
    </div>
  );
};

export default styled(DoughnutGraph)`
  height: ${(props) => (props.customSize ? props.customSize : '70px')};
  width: ${(props) => (props.customSize ? props.customSize : '70px')};
  overflow: visible;
`;
